const env = require("app/services/env");

export function trackAddToCart (payload) {
  const dataLayer = window.dataLayer || []
  const _learnq = window._learnq || []

  const lastItem = payload.items[payload.items.length - 1]
  const addedItems = getCartContent([lastItem]).Items

  dataLayer.push({
    event: 'addToCart',
    ecommerce: {
      currencyCode: env.get('currency.alpha_code'),
      add: {
        products: mapItemsForDataLayer(addedItems)
      }
    }
  })

  _learnq.push(['track', 'Added To Cart', {
    $value: payload.price.total,
    AddedItemProductName: lastItem.name,
    AddedItemProductID: lastItem.product,
    AddedItemCategories: [lastItem.type],
    AddedItemImageURL: lastItem.thumbnail,
    AddedItemURL: window.location.href,
    AddedItemPrice: lastItem.price,
    AddedItemQuantity: 1,
    ...getCartContent(payload.items)
  }])
}

export function trackInitiateCheckout (items = []) {
  const dataLayer = window.dataLayer || []
  const _learnq = window._learnq || []
  const content = getCartContent(items)

  dataLayer.push({
    event: 'initiateCheckout',
    ecommerce: {
      currencyCode: env.get('currency.alpha_code'),
      products: mapItemsForDataLayer(content.Items)
    }
  })

  _learnq.push(['track', 'InitiateCheckout', {
    ...content,
    $value: content.Items.reduce((a, b) => a + b.ItemPrice, 0)
  }])
}

export function getCartContent (items = []) {
  return items.reduce((acc, item) => {
    acc.ItemNames.push(item.name)
    acc.Items.push({
      ProductID: item.product,
      ProductName: item.name,
      Quantity: 1,
      ItemPrice: item.price,
      ImageURL: item.thumbnail,
      ProductCategories: [item.type]
    })

    if (item.ribbon && item.ribbon.name !== undefined) {
      acc.ItemNames.push(item.ribbon.name.name)
      acc.Items.push({
        ProductID: `RIBBON${item.ribbon.name.id}`,
        ProductName: item.ribbon.name.name,
        Quantity: 1,
        ItemPrice: item.ribbon.name.price,
        ProductCategories: ['ribbon']
      })
    }

    if (item.extras && item.extras.card > 0) {
      acc.ItemNames.push('Pænt kort til lejligheden')
      acc.Items.push({
        ProductID: `CARD${item.textCard}`,
        ProductName: 'Pænt kort til lejligheden',
        Quantity: 1,
        ItemPrice: item.extras.card,
        ProductCategories: ['card']
      })
    }

    return acc
  }, { Items: [], ItemNames: [] })
}

export function mapItemsForDataLayer (items = []) {
  return items.map(item => ({
    id: item.ProductID,
    name: item.ProductName,
    price: item.ItemPrice,
    category: item.ProductCategories,
    quantity: 1
  }))
}
